// src/pages/VerifyPage.tsx
import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { authApi } from "../lib/auth-api";
import { AuthLayout } from "./LoginPage";

export function VerifyPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const qc = useQueryClient();
  const [state, setState] = useState<
    { kind: "loading" }
    | { kind: "ok"; via_whitelist: boolean; message: string }
    | { kind: "error"; error: string }
  >({ kind: "loading" });

  useEffect(() => {
    if (!token) { setState({ kind: "error", error: "token がありません" }); return; }
    authApi.verify(token)
      .then(async (r) => {
        await qc.invalidateQueries({ queryKey: ["auth", "me"] });
        setState({ kind: "ok", via_whitelist: r.via_whitelist, message: r.message });
      })
      .catch((e) => setState({ kind: "error", error: (e as Error).message }));
  }, [token, qc]);

  return (
    <AuthLayout title="メールアドレス確認">
      {state.kind === "loading" && (
        <div className="text-sm text-slate-500 animate-pulse">確認中…</div>
      )}
      {state.kind === "ok" && (
        <>
          <p className="text-sm text-slate-700 leading-relaxed">{state.message}</p>
          <div className="mt-5 text-center text-sm">
            {state.via_whitelist ? (
              <Link to="/" className="text-blue-700 hover:underline">ダッシュボードへ →</Link>
            ) : (
              <Link to="/login" className="text-blue-700 hover:underline">ログイン画面に戻る</Link>
            )}
          </div>
        </>
      )}
      {state.kind === "error" && (
        <>
          <div className="auth-error">{state.error}</div>
          <div className="mt-3 text-xs text-slate-500">
            token が無効・期限切れの可能性があります。 もう一度サインアップしてください。
          </div>
          <div className="mt-5 text-center text-sm">
            <Link to="/signup" className="text-blue-700 hover:underline">新規登録</Link>
          </div>
        </>
      )}
    </AuthLayout>
  );
}
